"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Customize = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("components");
var overwrite = "$some_variable: <some value>;\n\n@import \"@estidlore/bonbon/scss/index.scss\";";
var Customize = function (_a) {
    var variables = _a.variables;
    return (react_1.default.createElement("section", null,
        react_1.default.createElement("p", { className: "f6" }, "Customize"),
        react_1.default.createElement("p", { className: "f5" }, "Variables"),
        react_1.default.createElement(components_1.Snippet, null, variables),
        react_1.default.createElement("p", null, "To overwrite a variable, only define it before the @import statement."),
        react_1.default.createElement(components_1.Snippet, null, overwrite)));
};
exports.Customize = Customize;
